
import type {
  AddPlanPropertyReq,
  AddPlanPropertyRes,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetPlanPropertiesRes,
  PlanPropertyVM,
  UpdatePlanPropertyReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function usePlanProperty() {
  class PlanProperty<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Plan property
     * @name PlanPropertyControllerGetPlanProperties
     * @summary Returns plan properties
     * @request GET:/api3/plan-property
     * @secure
     * @response `200` `GetPlanPropertiesRes`
     * @response `400` `BaseErrorResponse`
     */
    planPropertyControllerGetPlanProperties = (
      query?: {
        /**
         * Include invisible fields
         * @example true
         */
        includeInvisible?: boolean;
        /**
         * Tree id
         * @example 1
         */
        treeId?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPlanPropertiesRes, BaseErrorResponse>({
        path: '/api3/plan-property',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan property
     * @name PlanPropertyControllerCreatePlanProperty
     * @summary Create plan property
     * @request POST:/api3/plan-property
     * @secure
     * @response `200` `AddPlanPropertyRes`
     * @response `400` `BaseErrorResponse`
     */
    planPropertyControllerCreatePlanProperty = (data: AddPlanPropertyReq, params: RequestParams = {}) =>
      this.request<AddPlanPropertyRes, BaseErrorResponse>({
        path: '/api3/plan-property',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan property
     * @name PlanPropertyControllerUpdatePlanProperty
     * @summary Update plan property
     * @request PUT:/api3/plan-property/{id}
     * @secure
     * @response `200` `PlanPropertyVM`
     * @response `400` `BaseErrorResponse`
     */
    planPropertyControllerUpdatePlanProperty = (id: number, data: UpdatePlanPropertyReq, params: RequestParams = {}) =>
      this.request<PlanPropertyVM, BaseErrorResponse>({
        path: `/api3/plan-property/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Plan property
     * @name PlanPropertyControllerDeletePlanProperty
     * @summary Delete plan property
     * @request DELETE:/api3/plan-property/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    planPropertyControllerDeletePlanProperty = (id: number, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/plan-property/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new PlanProperty();
}
